import { ACTIONS, GAME_ID, SCREENS } from '../dataManagement/Constants';

const initialState = { definitionIndex: -1 };

const instructionViewData = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case ACTIONS.INIT_SHADES_SESSION:
      return initialState;

    case ACTIONS.CHANGE_SCREEN:
      if (action.payload.screen === SCREENS.INSTRUCTION) {
        return { definitionIndex: -1 };
      }
      return state;

    case ACTIONS.NEXT_INSTRUCTION_DEFINITION:
      return { definitionIndex: state.definitionIndex + 1 };

    default:
      return state;
  }
};

export default instructionViewData;
